
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class MileageField extends Vue {
  val = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  value!: any;

  @Prop()
  placeholder!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
